import type { TreeNode } from 'primeng/api';

export interface OrgUnitTreeSource {
  orgUnitId: string;
  name: string;
  parentId?: string | null;
  type?: string | null;
  orgPath?: string | null;
  isActive?: boolean;
}

export function buildOrgUnitTreeOptions<T extends OrgUnitTreeSource>(units: T[]): TreeNode[] {
  const activeUnits = units.filter((unit) => unit.isActive !== false);
  const nodesById = new Map<string, TreeNode>();
  const roots: TreeNode[] = [];

  for (const unit of activeUnits) {
    nodesById.set(unit.orgUnitId, {
      key: unit.orgUnitId,
      label: unit.name,
      data: unit,
      children: [],
      expanded: false,
    });
  }

  for (const unit of activeUnits) {
    const node = nodesById.get(unit.orgUnitId);
    if (!node) continue;

    const parent = unit.parentId ? nodesById.get(unit.parentId) : undefined;
    if (parent) {
      parent.children = [...(parent.children || []), node];
    } else {
      node.expanded = true;
      roots.push(node);
    }
  }

  const sortNodes = (nodes: TreeNode[]): TreeNode[] => nodes
    .map((node) => ({ ...node, children: sortNodes(node.children || []) }))
    .sort((left, right) => String(left.label || '').localeCompare(String(right.label || '')));

  return sortNodes(roots);
}
